import React from 'react';

const PageBreak = ({ label } : { label: string }) => {
  return (
    <div className="d-flex align-items-center gap-3 text-muted">
      <hr className="flex-fill border" />
      <h5 className="text-muted px-4">
        {label}
      </h5>
      <hr className="flex-fill border" />
    </div>
  );
};

export default PageBreak;
